import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC4EMjlr7ytwSJcDG11w2YHfKaRJc6jIn8",
  authDomain: "md-shift-app.firebaseapp.com",
  projectId: "md-shift-app",
  storageBucket: "md-shift-app.appspot.com",
  messagingSenderId: "519753584518",
  appId: "1:519753584518:web:6750e962fe40d319d22607"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);


export default db;